export default {
      id: "icon-reopen-fund-usage",
      viewBox: "-4 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-reopen-fund",
      toString: function () {
        return this.url;
      }
    }